import type { FormFieldType, FieldRenderer } from '../types'
import renderDefaultField from './renderDefaultField'
import renderPhoneField from './renderPhoneField'
import renderCountryField from './renderCountryField'
import renderCountryReadonlyField from './renderCountryReadonlyField'
import renderSelectField from './renderSelectField'
import renderPasswordField from './renderPasswordField'
import renderCheckboxField from './renderCheckboxField'
import renderExpDateField from './renderExpDateField'
import renderCardNumberField from './renderCardNumberField'
import renderCvvField from './renderCvvField'

// Lookup map for field-type → renderer. Anything not listed (text / email)
// falls back to `renderDefaultField` in the orchestrator.
export const fieldRenderers: Partial<Record<FormFieldType, FieldRenderer>> = {
    phone: renderPhoneField,
    country: renderCountryField,
    country_readonly: renderCountryReadonlyField,
    select: renderSelectField,
    password: renderPasswordField,
    checkbox: renderCheckboxField,
    exp_date: renderExpDateField,
    card_number: renderCardNumberField,
    cvv: renderCvvField
}

export { renderDefaultField }
export default fieldRenderers
